import { testimonials } from '../../../mocks/news';

const principles = [
  { icon: 'ri-speed-line', title: '快', desc: '24 小时编辑值班，刷屏事件最快几分钟内出快讯，先于大部分平台一步。' },
  { icon: 'ri-eye-close-line', title: '全', desc: '不满足于单方说法，持续补充时间线、当事人回应与多方信源，让瓜完整呈现。' },
  { icon: 'ri-mental-health-line', title: '冷静', desc: '拒绝标题党与网暴煽动，标注信息可信度，倡导理性吃瓜、独立思考。' },
  { icon: 'ri-shield-check-line', title: '严谨', desc: '重要事件做二次信源核验，涉及隐私与未成年人内容优先从严处理。' },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-24 py-12 md:py-16 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 items-center">
          <div className="relative">
            <div className="relative w-full h-[360px] md:h-[440px] rounded-2xl overflow-hidden border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=editorial%20newsroom%20desk%20with%20stacks%20of%20printed%20pages%20coffee%20and%20a%20desk%20lamp%20glow%2C%20warm%20amber%20and%20vermilion%20palette%2C%20cinematic%20moody%20lighting%2C%20textured%20paper%2C%20no%20text&width=900&height=700&seq=about-main-16&orientation=portrait"
                alt="吃瓜热点编辑部工作台"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-5 left-5 right-5 md:left-8 md:right-auto rounded-xl bg-primary-500 text-background-50 px-5 py-4 shadow-none">
              <p className="text-xs text-background-100/90 font-medium">我们的信念</p>
              <p className="font-heading text-base md:text-lg font-black mt-0.5">快是态度，冷是专业，真才是底线</p>
            </div>
          </div>

          <div>
            <span className="text-xs font-semibold text-primary-600 tracking-widest uppercase">ABOUT US</span>
            <h2 className="mt-1 font-heading text-2xl md:text-4xl font-black text-foreground-950">关于吃瓜热点</h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <strong className="text-foreground-900">吃瓜热点</strong> 是一支专注全网突发热点与娱乐猛料的原创内容团队。
              我们相信，真正的「吃瓜」不只是围观热闹，更要在第一时间看懂事件全貌。从明星娱乐到社会热点，从直播翻车到网络爆梗，我们以编辑部的方式持续追踪、整理与核实，
              陪你在这个信息爆炸的时代，抢先一步、清醒地吃到每一口新鲜的瓜。
            </p>
            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
              {principles.map((p) => (
                <div key={p.title} className="flex gap-3 items-start rounded-xl bg-background-50 border border-background-200 p-4 hover:border-background-300 transition">
                  <span className="flex w-9 h-9 shrink-0 items-center justify-center rounded-lg bg-accent-100 text-accent-800">
                    <i className={`${p.icon} text-lg`} aria-hidden="true" />
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-bold text-foreground-950">{p.title}</h3>
                    <p className="mt-1 text-xs text-foreground-600 leading-relaxed">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* 口碑 */}
        <div className="mt-16 md:mt-20">
          <div className="flex items-center gap-3 mb-7">
            <span className="flex items-center gap-0.5 text-accent-600">
              <i className="ri-star-fill" aria-hidden="true" /><i className="ri-star-fill" aria-hidden="true" /><i className="ri-star-fill" aria-hidden="true" /><i className="ri-star-fill" aria-hidden="true" /><i className="ri-star-fill" aria-hidden="true" />
            </span>
            <h3 className="font-heading text-xl md:text-2xl font-black text-foreground-950">读者怎么说</h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 md:gap-5">
            {testimonials.map((t) => (
              <figure key={t.name} className="flex flex-col justify-between rounded-2xl border border-background-200 bg-background-50 p-5 hover:border-background-300 transition">
                <i className="ri-double-quotes-l text-2xl text-primary-200" aria-hidden="true" />
                <blockquote className="mt-3 text-sm text-foreground-700 leading-relaxed flex-1">{t.text}</blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex w-9 h-9 items-center justify-center rounded-full bg-secondary-100 text-secondary-800 font-heading font-bold text-sm">
                    {t.name.charAt(0)}
                  </span>
                  <div>
                    <div className="text-sm font-semibold text-foreground-950">{t.name}</div>
                    <div className="text-xs text-foreground-400">{t.role}</div>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}